import { spacing } from './tailwind';

export const Gap = (value = 3): Record<'gap', number> | undefined => {
  if (!spacing[value]) return undefined;
  return { gap: Number(spacing[value].replace('px', '')) };
};
